import { z } from "zod";

/**
 * Medal tally: the filters live in the URL (`/medals?sport=…&noc=…`), so
 * Back, a reload and a copied link show the same page. `noc` is the drill-down
 * (a clicked tally row); `sport` narrows the medal list. A bad value is
 * dropped, never an error page. The games is the sidebar's current games.
 */
const id = z.string().uuid().optional().catch(undefined);
export const medalsSearch = z.object({ sport: id, noc: id });
export type MedalsSearch = z.infer<typeof medalsSearch>;

/** The FilterBar's draft: empty strings for "any", like a form. */
export interface MedalsDraft extends Record<string, unknown> {
	sport: string;
	noc: string;
}

export const EMPTY_MEDALS_DRAFT: MedalsDraft = { sport: "", noc: "" };

export const medalsDraftFromSearch = (s: MedalsSearch): MedalsDraft => ({ sport: s.sport ?? "", noc: s.noc ?? "" });

export const medalsSearchFromDraft = (d: MedalsDraft): MedalsSearch => ({ sport: d.sport || undefined, noc: d.noc || undefined });

/** How many filters are set (the Reset badge). */
export const medalsFilterCount = (s: MedalsSearch): number => [s.sport, s.noc].filter((v) => v !== undefined).length;

/** `GET /medals` filters for one games. */
export interface MedalListFilters {
	games_id: string;
	sport_id?: string;
	responsible_organization_id?: string;
}

export const medalListFilters = (gamesId: string, s: MedalsSearch): MedalListFilters => ({
	games_id: gamesId,
	sport_id: s.sport,
	responsible_organization_id: s.noc,
});

/** Which heading the medal list carries — it says what the list is narrowed to. */
export type MedalListScope = "latest" | "noc" | "sport" | "nocSport";

export function medalListScope(s: MedalsSearch): MedalListScope {
	if (s.noc && s.sport) return "nocSport";
	if (s.noc) return "noc";
	if (s.sport) return "sport";
	return "latest";
}
